module.exports = __webpack_public_path__ + "img/location_icon.69c65ed2.svg";